// A React component to be rendered in the top-right corner of a content page
export default () => null;
